/**
 * 页面文案词典 —— English
 * Batch 5: Compliance · Sanctions Screening Review (Compliance/SanctionsReview)
 */
export default {
  // ---- Menu (ProLayout looks up `menu.` prefix; bare key kept as fallback) ----
  'menu.制裁筛查复核': 'Sanctions Review',
  '制裁筛查复核': 'Sanctions Review',

  // ---- Page ----
  '制裁名单筛查': 'Sanctions Screening',
  '命中总数': 'Total Hits',
  '待复核': 'Pending Review',
  '确认命中': 'Confirmed Hit',
  '误报放行': 'False Positive',
  '已处置': 'Resolved',
  '名单条目数': 'List Entries',
  '同步时间': 'Last Synced',
  '数据年龄': 'Data Age',
  '小时': 'hours',
  '名单尚未同步，请检查定时任务 /usr/local/bin/sync-sanctions.php': 'List not synced yet. Check the cron job /usr/local/bin/sync-sanctions.php',
  'ID': 'ID',
  '个人': 'Individual',
  '查询名称': 'Submitted Name',
  '命中的名单条目': 'Matched List Entry',
  '名单项目': 'Sanctions Program',
  '匹配度': 'Match Score',
  '处置说明': 'Disposition Note',
  '处置说明（可选）': 'Disposition note (optional)',
  '命中时间': 'Matched At',
  '确认识别为名单对象': 'Confirm as Sanctioned Party',
  '判定为误报': 'Mark as False Positive',
  '确认识别必须填写处置说明': 'A disposition note is required to confirm the match',
  '处置成功': 'Disposition saved',

  // ===== Administrator management (edit entry added 09-28) =====
  '管理员': 'Administrator',
  '管理员列表': 'Administrators',
  '未填写': 'Not set',
  '编辑管理员': 'Edit Administrator',
  '密码留空表示不修改': 'Leave blank to keep the current password',
  '更新成功': 'Updated',
  '创建成功': 'Created',
  '删除成功': 'Deleted',
  '确定删除这个管理员吗': 'Delete this administrator?',
  '注销': 'Deregister',
  '注销名册': 'Closure Register',
  '账户注销': 'Account Deregistration',
  '确认注销': 'Confirm deregistration',
  '正在核验余额…': 'Verifying balance…',
  '注销成功，ID 已进注销仓库，余额已回收': 'Deregistered. ID moved to the closure registry, balance reclaimed.',
  '注销失败：': 'Deregistration failed: ',
  '注销原因': 'Reason',
  '进注销仓库留痕': 'recorded in the closure registry',
  '请填写注销原因': 'Please state the reason',
  '将回收金额': 'Amount to reclaim',
  '资金去向': 'Funds destination',
  '流水备注': 'Ledger remark',
  '该账号已注销过，请勿重复操作': 'This account is already deregistered — do not repeat.',
  '注销单号': 'Closure No.',
  '已回收': 'Reclaimed',
  '脱敏手机': 'Mobile (masked)',
  '注销时余额': 'Balance at closure',
  '可否再用': 'Reusable',
  '可复用': 'Yes',
  '不可': 'No',
  '账号已删除': 'Row purged',
  '注销时间': 'Closed at',

  // ---- 资金发行 / 回收审核（老陈 2026-09-29 定调：只有陈少华与吴琼）----
  '已提交，待发行审核：需陈少华或吴琼凭体系外收款凭据批准后入账': 'Submitted for issuance approval: Chen Shaohua or Wu Qiong must approve it with the off-system payment receipt before it is credited.',
  '无发行审核权限：仅陈少华与吴琼可批准发行': 'No issuance approval rights: only Chen Shaohua and Wu Qiong may approve issuance',
  '请填写体系外收款凭据：没收到真金白银就不发行货币': 'Enter the off-system payment receipt: no real money received, no credits issued',
  '后台发行审核': 'Issuance approved in admin',
  '发行审核通过，已入账': 'Issuance approved and credited',
  '审核发行': 'Approve issuance',
  '待发行审核': 'Pending issuance approval',
  '发行审核 · 批准入账': 'Issuance approval · credit wallet',
  '确认发行': 'Confirm issuance',
  '体系外收款凭据': 'Off-system payment receipt',
  '银行流水号 / 支付宝微信收款订单号': 'Bank reference / Alipay-WeChat payment order no.',
  '如：BANK20260929001 / 2026092922001xxxx': 'e.g. BANK20260929001 / 2026092922001xxxx',
  '顺序：先收到体系外的真金白银 → 授权 → 才发行体系内流通积分。凭据写入渠道流水号备查。': 'Order: real money received first → approval → then credits are issued. The receipt is stored as the channel reference.',
  '订单号：': 'Order no.: ',
  '提交后订单进入「待支付」，不会立即入账。需陈少华或吴琼在列表点「审核发行」并填写体系外收款凭据后才发行流通积分': 'After submitting, the order stays "pending" and is NOT credited yet. Chen Shaohua or Wu Qiong must click "Approve issuance" and enter the off-system payment receipt before credits are issued.',
  '没收到真金白银就不发行货币': 'No real money received, no credits issued',
  '无资金审核权限：仅陈少华与吴琼可审核提现': 'No fund approval rights: only Chen Shaohua and Wu Qiong may audit withdrawals',
  '请填写打款凭据：必须先把钱打给用户，才能回收流通积分': 'Enter the payout reference: money must reach the user before credits are recycled',
  '无审核权限': 'No approval rights',
  '体系外打款凭据': 'Off-system payout reference',
  '银行流水号 / 支付宝微信订单号': 'Bank reference / Alipay-WeChat order no.',
  '顺序：先把真金白银打给用户 → 才回收流通积分。没填凭据不会扣减企业余额。': 'Order: pay the user first → then recycle credits. Without a reference the company balance is not deducted.',

  // ---- NaturalPerson 自然人管理（2026-09-30 新增页）----
  '该自然人没有可操作的登录账号': 'This natural person has no login account to operate on',
  '已停用': 'Disabled',
  '实名状态': 'ID verified',
  '身份证': 'ID number',
  '账号状态': 'Account status',
  '推荐码': 'Referrer code',
  '注册时间': 'Registered at',
  '确认停用该账号？停用后无法登录。': 'Disable this account? The user will no longer be able to sign in.',
  '确认启用该账号？': 'Enable this account?',
  '自然人总数': 'Total natural persons',
  // 统计卡片里的「已实名」是**数量**，译为 Verified；列头「实名状态」才是 ID verified
  '已实名': 'Verified',
  '账号已停用': 'Accounts disabled',
  '账号已注销': 'Accounts deleted',
  '搜索姓名 / 全球ID / 手机号': 'Search name / global ID / mobile',

  // ---- #719 编辑 / 实名复核（2026-09-30）----
  '编辑': 'Edit',
  '编辑自然人': 'Edit natural person',
  '显示名称': 'Display name',
  '真实姓名': 'Real name',
  '请输入显示名称': 'Please enter a display name',
  '保存成功': 'Saved',
  '保存失败': 'Save failed',
  '待复核': 'Pending review',
  '已驳回': 'Rejected',
  '复核通过': 'Approve',
  '驳回': 'Reject',
  '退回待复核': 'Back to pending',
  '已通过实名复核': 'ID verification approved',
  '确认通过该自然人的实名复核？': 'Approve ID verification for this natural person?',
  '确认驳回？驳回后该自然人需重新提交实名资料。':
    'Reject? The person will need to resubmit ID documents.',
  '确认将该自然人退回「待复核」？': 'Send this natural person back to \u201cpending review\u201d?',
  '（实名信息不可手改，需重新实名）': '(ID info cannot be edited manually; re-verification required)',
  '该手机号即登录账号，改动后请用新号码登录':
    'This mobile is the login account; sign in with the new number after change',
  '当前筛选': 'Filter',
  '清除筛选': 'Clear filter',
};
